var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Vue from 'vue';
var zlib = require('zlib');
import { Process } from "../../../../lib/process/process.cls";
import { WsConnector } from "../../../../lib/ws/ws-connector.cls";
import { scalpertMixins } from '../../../../scalpert/';
var PriceFeedSeeder = /** @class */ (function (_super) {
    __extends(PriceFeedSeeder, _super);
    function PriceFeedSeeder(iProvider) {
        var _this = _super.call(this, iProvider) || this;
        /**
         * HTML5 WebSocket wrapper
         */
        _this.wsConnector = null;
        _this.onopen = function (ev) {
            //this.log(PriceFeedSeeder.TAG, 'open connection at url' + 
            // this.settings.ENDPOINT) 
            var liveToken = _this.iProvider.getStore().getters['GET_TOKEN'];
            // scalpertMixins.methods.update_socket_indicator(1)
            try {
                _this.auth({ auth: liveToken,
                    defaults: _this.settings.defaultIsinIds });
            }
            catch (ex) { }
        };
        /**
         * handle message from webocket
         */
        _this.heartbeat = 0;
        _this.onmessage = function (ev) {
            try {
                var _that_1 = _this;
                // const jsonMsg = JSON.parse(ev.data)  
                // scalpertMixins.methods.update_socket_indicator(1)
                var responseBuffer = new Buffer(ev.data, 'base64');
                zlib.unzip(responseBuffer, function (err, buffer) {
                    if (!err) {
                        var jsonMsg = JSON.parse(buffer.toString());
                        if (Object.keys(jsonMsg).length != 0) {
                            if ('isins' in jsonMsg) { // on auth, su
                                if ('subscribe' in jsonMsg) {
                                    // add the array of isin-ids to the cache
                                    _that_1.iProvider.addItems(jsonMsg);
                                    return;
                                }
                                return;
                            }
                            // else if ('order_update' in jsonMsg) {
                            //   //console.log("non over here", jsonMsg)
                            //   // ._store.commit(Const.SET_OPEN_POSITION, jsonMsg[Object.keys(jsonMsg)[0]]
                            //   scalpertMixins.methods.update_positions(jsonMsg["order_update"])
                            //   //commit(Const.SET_OPEN_POSITION, jsonMsg[Object.keys(jsonMsg)[0]])
                            // }
                            else if ('open_order_data' in jsonMsg) {
                                // scalpertMixins.methods.update_user_log()
                                scalpertMixins.methods.update_orders_state(jsonMsg["open_order_data"]);
                            }
                            else if ('open_position_data' in jsonMsg) {
                                // scalpertMixins.methods.update_user_log()
                                scalpertMixins.methods.update_position_state(jsonMsg["open_position_data"]);
                            }
                            else if ('watchListName' in jsonMsg) {
                                // console.log(jsonMsg["watchListName"])
                                // scalpertMixins.methods.update_watch_list(jsonMsg["watchListName"])
                            }
                            else if ('message' in jsonMsg) {
                                var vm = new Vue();
                                var messages = jsonMsg['message'];
                                if ("Emsg" in messages) {
                                    if (messages['stat'] === 'Not_Ok') {
                                        vm.$notify({
                                            group: 'foo',
                                            title: 'Something went wrong!',
                                            text: messages['Emsg'],
                                            type: 'error',
                                        });
                                    }
                                    if (messages['stat'] === 'Not_Ok_Reject') {
                                        vm.$notify({
                                            group: 'foo',
                                            title: messages['Emsg'],
                                            text: messages['resp_msg'],
                                            type: 'error',
                                        });
                                    }
                                    else if (messages['stat'] === 'Ok') {
                                        vm.$notify({
                                            group: 'foo',
                                            title: 'Success!',
                                            text: messages['resp_msg'],
                                            type: 'success',
                                        });
                                    }
                                }
                            }
                            else if ('searchText' in jsonMsg) {
                                _that_1.iProvider.saveSearchResult(jsonMsg['searchText']);
                            }
                            else if ('depth' in jsonMsg) {
                                // console.log("non over here", jsonMsg)
                                // ._store.commit(Const.SET_OPEN_POSITION, jsonMsg[Object.keys(jsonMsg)[0]]
                                scalpertMixins.methods.update_depth(jsonMsg["depth"]);
                                //commit(Const.SET_OPEN_POSITION, jsonMsg[Object.keys(jsonMsg)[0]])
                            }
                            else {
                                // patch cache entries from the mappings
                                // console.log(jsonMsg)
                                _that_1.iProvider.patchItems(jsonMsg);
                            }
                        }
                    }
                });
            }
            catch (exo) {
                //this.log(PriceFeedSeeder.TAG, 'onmessage EXC', exo)
            }
        };
        _this.onclose = function (ev) {
            // scalpertMixins.methods.update_socket_indicator(3)
            //this.log(PriceFeedSeeder.TAG, 'onclose...', ev)
        };
        _this.onerror = function (ev) {
            // scalpertMixins.methods.update_socket_indicator(2)
            //this.log(PriceFeedSeeder.TAG, 'onerror...', ev)
        };
        _this.onconnecting = function () {
            // scalpertMixins.methods.update_socket_indicator(0)
            //this.log(PriceFeedSeeder.TAG, 'onconnecting...')
        };
        return _this;
        //iProvider.getStore()
        //this.log(PriceFeedSeeder.TAG, 'pid', this.settings.pid)
    }
    PriceFeedSeeder.prototype.sendMessage = function (jsonMsg) {
        try {
            //this.log(PriceFeedSeeder.TAG, 'sendMessage', jsonMsg)
            this.wsConnector.send(JSON.stringify(jsonMsg));
        }
        catch (ex) {
            //this.log(PriceFeedSeeder.TAG, 'sendMessage EXC', {jsonMsg, ex:ex.message})
        }
    };
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    PriceFeedSeeder.prototype.auth = function (params) {
        //this.log(PriceFeedSeeder.TAG, 'auth [params]', params)
        try {
            this.sendMessage(params);
        }
        catch (ex) {
            //this.log(PriceFeedSeeder.TAG, 'auth [ex]', ex.message)
        }
    };
    /**
     * @Override
     * subscribe tp a resource
     * @param ids either an array of ids or a key -> objecr mapping
     */
    PriceFeedSeeder.prototype.subscribe = function (ids) {
        // console.log("subscribe", ids)
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ subscribe: ids });
        this.iProvider.heartbeat();
    };
    PriceFeedSeeder.prototype.subscribeMW = function (ids) {
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ subscribeMW: ids });
        this.iProvider.iCache.clearCache();
        // this.iProvider.heartbeat()
        // this.wsConnector.connect()
        // this.wsConnector.stop(this.iProvider.settings)
        // this.iProvider.iCache.start(this.iProvider.settings)
    };
    PriceFeedSeeder.prototype.unsubscribeAll = function (ids) {
        //  console.log(this.iProvider.settings)
        // this.iProvider.iCache.stop()
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ unsubscribeAll: ids });
        this.iProvider.patchItems(ids, true);
        this.iProvider.iCache.clearCache();
    };
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    PriceFeedSeeder.prototype.unsubscribe = function (ids) {
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ unsubscribe: ids });
        this.iProvider.patchItems(ids, true);
    };
    PriceFeedSeeder.prototype.marketDepth = function (ids) {
        this.sendMessage({ dp: ids });
    };
    PriceFeedSeeder.prototype.placeOrderViaSocket = function (orders) {
        this.sendMessage({ orderDetail: orders });
    };
    PriceFeedSeeder.prototype.squareoffHolding = function (orders) {
        this.sendMessage({ squareoffHolding: orders });
    };
    PriceFeedSeeder.prototype.placeBOViaSocket = function (orders) {
        this.sendMessage({ BO: orders });
    };
    PriceFeedSeeder.prototype.modifyOrderViaSocket = function (orders) {
        this.sendMessage({ modify: orders });
    };
    PriceFeedSeeder.prototype.cancelOrderViaSocket = function (orders) {
        this.sendMessage({ cancelOrder: orders });
    };
    PriceFeedSeeder.prototype.exitCoverViaSocket = function (orders) {
        this.sendMessage({ exitCover: orders });
    };
    PriceFeedSeeder.prototype.exitBOViaSocket = function (orders) {
        this.sendMessage({ exitBo: orders });
    };
    PriceFeedSeeder.prototype.searchIsinsViaSocket = function (searchData) {
        this.sendMessage({ searchIsins: searchData });
    };
    PriceFeedSeeder.prototype.squareoffViaSocket = function (searchData) {
        this.sendMessage({ squareoff: searchData });
    };
    PriceFeedSeeder.prototype.subscribeIndex = function (searchData) {
        this.sendMessage({ indexToBeSubscribe: searchData });
    };
    PriceFeedSeeder.prototype.closeWs = function (params) {
        try {
            // scalpertMixins.methods.update_socket_indicator(3)
            this.wsConnector.stop(params);
        }
        catch (ex) {
            //this.log('closing websocket', ex.message)
        }
    };
    /**
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    PriceFeedSeeder.prototype.start = function (params) {
        //this.log(PriceFeedSeeder.TAG, 'start', params)
        this.settings = params;
        try {
            // scalpertMixins.methods.update_socket_indicator(3)
            this.settings.onopen = this.onopen;
            this.settings.onclose = this.onclose;
            this.settings.onconnecting = this.onconnecting;
            this.settings.onmessage = this.onmessage;
            this.wsConnector = new WsConnector();
            this.wsConnector.start(this.settings);
            //this.log(PriceFeedSeeder.TAG, 'this.iProvider.settings', 
            // this.iProvider.settings)
        }
        catch (ex) {
            //this.log(PriceFeedSeeder.TAG, 'start [ex]', ex)
        }
    };
    /**
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    PriceFeedSeeder.prototype.stop = function (params) {
        try {
            // scalpertMixins.methods.update_socket_indicator(3)
            this.closeWs(params);
            //this.log(PriceFeedSeeder.TAG, "stop done")
        }
        catch (ex) {
            //this.log(PriceFeedSeeder.TAG, "stop [ex]", ex)
        }
    };
    PriceFeedSeeder.TAG = 'PriceFeedSeeder';
    return PriceFeedSeeder;
}(Process));
export { PriceFeedSeeder };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/seeder/price-feed-seeder.cls.ts
// module id = 359K
// module chunks = 76